import {useQuery} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {components} from '@/lib/api-schema'

export type Onboarding = components['schemas']['OnboardingRead']

export function useMyOnboarding(businessId: string | undefined) {
  return useQuery({
    queryKey: ['mi-onboarding', businessId],
    queryFn: async () => (await api.get<Onboarding>(`/businesses/${businessId}/mi/onboarding`)).data,
    enabled: !!businessId,
  })
}
